import React, { Component, useState, useEffect } from 'react';
import RandomProjects from '../components/RandomProjects';
import config from '../Config';
import CoverImage from '../components/CoverImage';

class Home extends Component {  
    
	componentDidMount() {
        document.title = `${config.name}`;
        window.scrollTo(0, 0); 
    }
    
    render() {
        
        return (
            <div className='b-light'>
                <div className='relative c-100 vh-85 b-dark p-r d-t'>
                    <CoverImage url='images/home.jpg' title={config.title} subtitle={config.subtitle} />
                </div>

                <div className='border-wrapper'>
                    <div className='border-card-item'>
                        <div class="b-pattern">
                            <div className='content-wrapper m-c p-tb-5'>

                                <div className='animated-item fade-in-slide-up delay-2 content-wrapper m-c b-light t-a-c'>
                                    <div className='p-2 border-item'>
                                        <h4 className='uppercase ervasera animated-item fade-in-slide-up'>Trasformo la tua casa in un riflesso limpido della tua identità</h4>
                                        <p className='m-t-2  animated-item fade-in-slide-up delay-1'>
                                        Con competenza e creatività, ti guido nell’espressione del tuo stile personale, creando ambienti funzionali e unici, che raccontano la tua storia. Con il mio metodo, trovo soluzioni che superano indecisioni e ispirano il tuo mondo. Solo chi non “si conosce” non può ispirarsi.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='b-dark'>
                    <div className='content-wrapper m-c p-t-10'>
                        <RandomProjects></RandomProjects>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home
